import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { TargetAudience } from './components/TargetAudience';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0c3b42] font-sans selection:bg-[#7fd1c9] selection:text-[#0c3b42]" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Benefits data-id="element-5" />
        <Modules data-id="element-6" />
        <Bonuses data-id="element-7" />
        <TargetAudience data-id="element-8" />
        <Pricing data-id="element-9" />
        <Testimonials data-id="element-10" />
        <FAQ data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}